import { client } from "@johnpaul/jp-api-client";
import { useQuery } from "@tanstack/react-query";

export const usePDF = (locale = "fr", enabled = false) => {
  return useQuery({
    queryKey: ["pdf", locale],
    queryFn: () => client.passes.pdf(locale),
    enabled,
    gcTime: 0,
    retry: false,
  });
};

export const usePass = (enabled = false) => {
  return useQuery({
    queryKey: ["pass"],
    queryFn: () => client.passes.pkPass(),
    enabled,
    gcTime: 0,
    retry: false,
  });
};
